import { AbstractControl } from '@angular/forms';

export class SelectDropdown0Validator {

    static selectDropdownCheck(c: AbstractControl): { [key: string]: any } {

        // if test is unsuccessful, return key(selectDropdownCheck)-value(false) pair
        // value of  --please select option -- is 0. We need to invalidate that
        // FIXME also add all posible values here for example for color : javor
        return (typeof c.value === 'string') ? null : { required: true };

    }

     // TODO add array of possibleValues here to check not only if it is string which means its not a zero, but also the values
    public static checkAvailableOptions(value: string): boolean {
        return true;
    }
}
